import React, { createContext } from 'react'

interface ApiContextType {
    Url: string;
}

const getApiUrl = (): string => {
    const hostname = window.location.hostname;
    
    // Local development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://localhost:8888/';
    }
    
    // Production
    if (hostname.includes('ridderendeprins.nl') && !hostname.includes('preview')) {
        return 'https://api-v2.ridderendeprins.nl/';
    }
    
    // Preview (default)
    return 'https://api-preview.ridderendeprins.nl/';
}

export const ApiContext = createContext<ApiContextType>({
    Url: getApiUrl()
})

const ApiContextProvider: React.FC<{ children: React.ReactNode }> = (props) => {
    const Url = getApiUrl()
    return (
        <ApiContext.Provider
            value={{
                Url
            }}>
            {props.children}
        </ApiContext.Provider>
    )
}
export default ApiContextProvider